import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-doc-article-search',
  templateUrl: './doc-article-search.component.html',
  styleUrls: ['./doc-article-search.component.css']
})
export class DocArticleSearchComponent implements OnInit {
    public setting?: Setting;

    public itemsListDocumentArticles: Item[] = [];

    public searchTextButtons: FormButton[] = [
        { id: 'erase', type: 'danger', icon: 'fa fa-solid fa-eraser', onClick: () => this.clear('searchtext') },
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadDocumentArticles() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1380))[0];
    }

    private async loadDocumentArticles() {
        if (!this.setting) return;

        return this.itemsListDocumentArticles = await this.datatask.Post(1381, { searchtext: this.setting.searchtext });
    }

    private clear(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                this.setting.searchtext = '';
                this.itemsListDocumentArticles = [];
                break;
            default:
                break;
        }
    }

    public searchItems() {
        this.loadDocumentArticles();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                if (this.setting.searchtext === '') {
                    this.itemsListDocumentArticles = [];
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadDocumentArticles();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
